module.exports = __webpack_public_path__ + "img/logo_u1992-32.61306c85.png";